export class Assinatura {
  fkIdDocumento: number = null;
  tpAssinatura: string = null;
  dtAssinatura: Date = null;
  bbDocumentopdf: Blob = null;
  /*
    bbAssinatura: string = null;
		tpAssinador: string = null;
		dtAssinaturaValidada: Date = null;
		bbAssinaturaValidada: string = null;*/
  constructor(d?) {
    if (d) {
      this.fkIdDocumento = d.fkIdDocumento ? d.fkIdDocumento : null;
      this.tpAssinatura = d.tpAssinatura ? d.tpAssinatura : null;
      this.dtAssinatura = d.dtAssinatura ? d.dtAssinatura : null;
      //this.bbAssinatura = d.bbAssinatura ? d.bbAssinatura : null;
      this.bbDocumentopdf = d.bbDocumentopdf ? d.bbDocumentopdf : null;
      //this.tpAssinador = d.tpAssinador ? d.tpAssinador : null;
      // this.dtAssinaturaValidada = d.dtAssinaturaValidada ? d.dtAssinaturaValidada : null;
      //this.bbAssinaturaValidada = d.bbAssinaturaValidada ? d.bbAssinaturaValidada : null;
    }
  }
}
